import { Suspense } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from '@src/store/store';
import AuthProvider from './auth/AuthProvider';
import AppContent from './AppContent';
import { ErrorBoundary } from './components/ErrorBoundary';
import { SpinLoading } from '@devotel/design-system';
import { WhiteLabelProvider } from './whiteLabel/WhiteLabelProvider';
import ThemeWrapper from './whiteLabel/ThemeWrapper';
import { WhiteLabelConfigProvider } from './whiteLabel/WhiteLabelConfigProvider';

const App = () => {
  return (
    <Provider store={store}>
      <AuthProvider>
        <BrowserRouter>
          <PersistGate loading={<SpinLoading />} persistor={persistor}>
            <ErrorBoundary>
              <Suspense fallback={<SpinLoading />}>
                <WhiteLabelProvider>
                  <ThemeWrapper>
                    <WhiteLabelConfigProvider>
                      <AppContent />
                    </WhiteLabelConfigProvider>
                  </ThemeWrapper>
                </WhiteLabelProvider>
              </Suspense>
            </ErrorBoundary>
          </PersistGate>
        </BrowserRouter>
      </AuthProvider>
    </Provider>
  );
};

export default App;
